(function () {
  var TIMER_STARTED_KEY = 'hoad_cart_timer_started_at';
  var timerIntervalStarted = false;

  // --- Cronômetro ---------------------------------------------------------

  function getTimerStartedAt() {
    var raw = null;
    try {
      raw = sessionStorage.getItem(TIMER_STARTED_KEY);
    } catch (e) {
      /* ignore */
    }
    if (raw) return parseInt(raw, 10);
    var now = Date.now();
    try {
      sessionStorage.setItem(TIMER_STARTED_KEY, String(now));
    } catch (e) {
      /* ignore */
    }
    return now;
  }

  function formatTimer(totalSeconds) {
    var m = Math.floor(totalSeconds / 60);
    var s = totalSeconds % 60;
    return (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
  }

  function tickTimer() {
    // Consulta o elemento vivo a cada tick em vez de guardar referência —
    // o drawer inteiro é recriado (innerHTML) a cada add/remove/troca de
    // quantidade, então uma referência antiga ficaria órfã.
    var el = document.querySelector('[data-hoad-cart-timer]');
    if (!el) return;

    var minutes = parseInt(el.dataset.minutes, 10) || 15;
    var startedAt = getTimerStartedAt();
    var remaining = minutes * 60 - Math.floor((Date.now() - startedAt) / 1000);

    if (remaining <= 0) {
      el.innerHTML = el.dataset.endText || '';
      return;
    }

    var template = el.dataset.text || '';
    el.innerHTML = template.replace('{timer}', '<strong>' + formatTimer(remaining) + '</strong>');
  }

  function ensureTimerRunning() {
    if (timerIntervalStarted) return;
    if (!document.querySelector('[data-hoad-cart-timer]')) return;
    timerIntervalStarted = true;
    tickTimer();
    setInterval(tickTimer, 1000);
  }

  // --- Botões de adicionar (upsell / proteção de envio) -------------------

  function addVariantAndRefreshDrawer(btn) {
    var variantId = btn.dataset.variantId;
    if (!variantId) return;
    btn.setAttribute('disabled', 'disabled');

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);

    var cartAddUrl = (window.theme && window.theme.routes && window.theme.routes.cart_add_url) || '/cart/add';

    fetch(cartAddUrl, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: formData
    })
      .then(function () {
        return fetch('/cart?section_id=cart-drawer');
      })
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newDrawer = doc.querySelector('.cart-drawer');
        var currentDrawer = document.querySelector('#Cart-Drawer');
        if (newDrawer && currentDrawer) {
          currentDrawer.innerHTML = newDrawer.innerHTML;
        }
      })
      .catch(function (err) {
        console.error('Hoad cart add error:', err);
        btn.removeAttribute('disabled');
      });
  }

  function bindAddButtons(selector) {
    document.querySelectorAll(selector).forEach(function (btn) {
      if (btn.dataset.hoadBound === 'true') return;
      btn.dataset.hoadBound = 'true';
      btn.addEventListener('click', function () {
        addVariantAndRefreshDrawer(btn);
      });
    });
  }

  function processAll() {
    ensureTimerRunning();
    bindAddButtons('[data-hoad-upsell-add]');
    bindAddButtons('[data-hoad-protection-add]');
  }

  var debounceTimer = null;
  function scheduleProcess() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(processAll, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processAll);
  } else {
    processAll();
  }

  var cartDrawer = document.getElementById('Cart-Drawer');
  if (cartDrawer && 'MutationObserver' in window) {
    var observer = new MutationObserver(scheduleProcess);
    observer.observe(cartDrawer, { childList: true, subtree: true });
  }

  document.addEventListener('cart-drawer:open', scheduleProcess);

  // --- "Deseja bojo?" (24/09, pedido do André) --------------------------------
  // Produto com a tag "bojo" mostra a pergunta dentro do item do carrinho
  // (snippets/cart-drawer.liquid). O padrão é "Não" (sem resposta = não recebe
  // bojo, e nada trava o checkout). Clicar grava a escolha na própria linha do
  // pedido (propriedade "deseja bojo?") via /cart/change.js.

  function redesenharDrawer(json) {
    var atual = document.getElementById('Cart-Drawer');
    var html = json && json.sections && json.sections['cart-drawer'];
    if (!atual || !html) return;
    var novo = new DOMParser().parseFromString(html, 'text/html').querySelector('.cart-drawer');
    if (novo) atual.innerHTML = novo.innerHTML;
    var bolha = json.sections['cart-bubble'];
    var toggle = document.getElementById('cart-drawer-toggle');
    if (bolha && toggle) {
      var b = new DOMParser().parseFromString(bolha, 'text/html').querySelector('.thb-item-count');
      var t = toggle.querySelector('.thb-item-count');
      if (b && t) t.innerHTML = b.innerHTML;
    }
  }

  function responderBojo(botao) {
    var caixa = botao.closest('[data-hoad-bojo-ask]');
    if (!caixa) return;
    var linha = Number(caixa.dataset.line);
    var chave = caixa.dataset.key || 'deseja bojo?';
    var escolha = botao.dataset.hoadBojoChoice;
    caixa.classList.add('is-saving');
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var item = cart.items[linha - 1];
        if (!item) throw new Error('linha do carrinho não encontrada');
        var props = Object.assign({}, item.properties || {});
        props[chave] = escolha;
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: linha, quantity: item.quantity, properties: props, sections: ['cart-drawer', 'cart-bubble'], sections_url: window.location.pathname })
        });
      })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        if (json && json.status && json.description) throw new Error(json.description);
        redesenharDrawer(json);
      })
      .catch(function (err) {
        console.error('Hoad bojo:', err);
        caixa.classList.remove('is-saving');
      });
  }

  document.addEventListener('click', function (e) {
    var escolha = e.target.closest('#Cart-Drawer [data-hoad-bojo-choice]');
    if (escolha) { e.preventDefault(); responderBojo(escolha); }
  }, true);
})();
